export enum Tenant {
    Vistaprint = 'VISTAPRINT',
    NinetyNineDesigns = '99DESIGNS',
}
